import {IComponentController, IComponentOptions, IScope} from "angular";
import './file-upload-croppie.component.scss';
import * as Croppie from "croppie";
import {CropData} from "croppie";
import {ImageUploadServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {ImageService} from "../../service/image.service";
import {ImageResponse} from "../../model/ImageModel";

interface CropImage {
    onCropDataChange?: (cropData: CropData) => void,
    source?: any,
    image?: CropData
}

interface FileUploadCroppieScope extends IScope {
    uploadImage: () => void;
    fileSelected: boolean;
    readFile: (file: any) => void;
    cropped: CropImage;
}

export class FileUploadCroppieComponent implements IComponentController {

    static instance: IComponentOptions = {
        template: require('./file-upload-croppie.component.html'),
        controller: ['$scope', ToastNotificationServiceName, ImageUploadServiceName, FileUploadCroppieComponent],
        bindings: {
            onUploadStart: '<',
            onUploadComplete: '<'
        }
    };

    private imageService: ImageService;
    private onUploadComplete: (resp: ImageResponse) => void;
    private onUploadStart: () => void;
    private $scope: FileUploadCroppieScope;
    private toastNotificationService: ToastNotificationService;

    constructor($scope: FileUploadCroppieScope,
                toastNotificationService: ToastNotificationService,
                imageService: ImageService) {
        $scope.readFile = this.readFile;
        $scope.cropped = {onCropDataChange: this.onCropDataChange};
        $scope.uploadImage = this.uploadImage;
        this.toastNotificationService = toastNotificationService;
        this.imageService = imageService;
        this.$scope = $scope;
    }

    uploadImage = () => {
        if (this.$scope.cropped.source) {
            let formData = ImageService.getInputFormData('image-input');
            this.appendCropData(formData);
            this.postImageFile(formData);
        } else {
            this.toastNotificationService.generateErrorMessage("Please select the image first.")
        }
    };

    appendCropData = (formData: FormData) => {
        let cropData = this.$scope.cropped.image.points;

        function addPoint(name: string, point: number) {
            formData.append(name, point.toString());
        }

        addPoint("x1", cropData[0]);
        addPoint("y1", cropData[1]);
        addPoint("x2", cropData[2]);
        addPoint("y2", cropData[3]);
    };

    private postImageFile(formData) {
        this.imageService.uploadImage(formData)
            .then(resp => {
                this.onUploadComplete(resp);
            });
        this.onUploadStart();
    }

    readFile = (file: any) => {
        let $scope = this.$scope;
        $scope.cropped.source = file;
        $scope.fileSelected = true;
    };

    onCropDataChange = (cropData: Croppie.CropData) => {
        this.$scope.cropped.image = cropData;
    }
}